
const AMBIFI_BASE_URI = "http://www.ambifi.com";
const AMBIFI_ACTIVITIES_BASE_URI = AMBIFI_BASE_URI + "/expapi/activities";
const AMBIFI_VERBS_BASE_URI = AMBIFI_BASE_URI + "/expapi/verbs";

const ADL_BASE_URI = "http://adlnet.gov/expapi";
const ADL_VERBS_BASE_URI = ADL_BASE_URI + "/verbs";
const ADL_ACTIVITIES_BASE_URI = ADL_BASE_URI + "/activities";


export default {

	AMBIFI_BASE_URI,
	AMBIFI_ACTIVITIES_BASE_URI,
	AMBIFI_VERBS_BASE_URI,

	ADL_VERBS: {
		EXPERIENCED: ADL_VERBS_BASE_URI + "/experienced",
		COMPLETED: ADL_VERBS_BASE_URI + "/completed",
		ATTEMPTED: ADL_VERBS_BASE_URI + "/attempted",
		ANSWERED: ADL_VERBS_BASE_URI + "/answered",
		EXITED: ADL_VERBS_BASE_URI + "/exited",
		SUSPENDED: ADL_VERBS_BASE_URI + "/suspended",
		RESUMED: ADL_VERBS_BASE_URI + "/resumed",
		VOIDED: ADL_VERBS_BASE_URI + "/voided",
		LAUNCHED: ADL_VERBS_BASE_URI + "/launched",
		INITIALIZED: ADL_VERBS_BASE_URI + "/initialized",
		TERMINATED: ADL_VERBS_BASE_URI + "/terminated"
	},

	ADL_ACTIVITY_TYPES: {
		CMI_INTERACTION: ADL_ACTIVITIES_BASE_URI + "/cmi.interaction"
	},

	AMBIFI_ACTIVITY_TYPES: {
		ACTIVITY: AMBIFI_ACTIVITIES_BASE_URI + "/activity",
		LIST: AMBIFI_ACTIVITIES_BASE_URI + "/list",
		SECTION: AMBIFI_ACTIVITIES_BASE_URI + "/section",
		ITEM: AMBIFI_ACTIVITIES_BASE_URI + "/item"
	}
}